/* eslint-disable @typescript-eslint/no-explicit-any */

function isHTMLTableCellElement(subject) {
  return subject instanceof HTMLTableCellElement;
}
function isHTMLTableRowElement(subject) {
  return subject instanceof HTMLTableRowElement;
}
function isHTMLTableSectionElement(subject) {
  return subject instanceof HTMLTableSectionElement;
}
function isHTMLTableElement(subject) {
  return subject instanceof HTMLTableElement;
}
function isHTMLDivElement(subject) {
  return subject instanceof HTMLDivElement;
}
function isInputElementEvent(subject) {
  return subject && subject.hasOwnProperty('currentTarget') && subject['currentTarget'] instanceof HTMLInputElement;
}

export { isHTMLDivElement, isHTMLTableCellElement, isHTMLTableElement, isHTMLTableRowElement, isHTMLTableSectionElement, isInputElementEvent };
//# sourceMappingURL=html-type-guards.esm.js.map
